import { Locales } from "../enums/locales";
const EMPTY_LINE = "<p><br></p>";
export const getFulfillmentReadyForPickupSubject = (locale) => {
    const subjects = {
        [Locales.EN]: "Your order is ready for pick-up 📦",
        [Locales.FR]: "Votre commande est prête pour le ramassage 📦",
        [Locales.ES]: "Tu pedido está listo para recoger 📦",
        [Locales.DE]: "Ihre Bestellung ist zur Abholung bereit 📦",
    };
    return subjects[locale];
};
export const getFulfillmentOrderShippedSubject = (locale) => {
    const subjects = {
        [Locales.EN]: "Your order has shipped 📦",
        [Locales.FR]: "Votre commande a été expédiée 📦",
        [Locales.ES]: "Tu pedido ha sido enviado 📦",
        [Locales.DE]: "Ihre Bestellung wurde versendet 📦",
    };
    return subjects[locale];
};
export const getFulfillmentReadyForPickupBodyTemplate = ({ locale, hasInstructions, }) => {
    const instructionsLabel = {
        [Locales.EN]: "Pick-up instructions:",
        [Locales.FR]: "Consignes de ramassage :",
        [Locales.ES]: "Instrucciones de recogida:",
        [Locales.DE]: "Abholhinweise:",
    };
    const instructions = hasInstructions
        ? EMPTY_LINE + `<p>📝 <strong>${instructionsLabel[locale]}</strong><br>{{Pickup instructions}}</p>`
        : "";
    const bodies = {
        [Locales.EN]: `<p>Hi {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Your order is ready for pick-up! Here are the details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Pick-up address:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Thank you for supporting [OrgName]!</p>`,
        [Locales.FR]: `<p>Bonjour {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Votre commande est prête pour le ramassage ! Voici les détails :</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Adresse de ramassage :</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Merci de votre soutien envers [OrgName] !</p>`,
        [Locales.ES]: `<p>Hola {{First name}},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido está listo para recoger! Estos son los detalles:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Dirección de recogida:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>¡Gracias por tu apoyo a [OrgName]!</p>`,
        [Locales.DE]: `<p>Hallo {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung ist zur Abholung bereit! Hier sind die Details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Abholadresse:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Vielen Dank für Ihre Unterstützung von [OrgName]!</p>`,
    };
    return bodies[locale];
};
export const getFulfillmentOrderShippedBodyTemplate = (locale) => {
    const bodies = {
        [Locales.EN]: `<p>Hi {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Your order has been shipped! Here are the details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Thank you for supporting [OrgName]!</p>`,
        [Locales.FR]: `<p>Bonjour {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Votre commande a été expédiée ! Voici les détails :</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Merci de votre soutien envers [OrgName] !</p>`,
        [Locales.ES]: `<p>Hola {{First name}},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido ha sido enviado! Estos son los detalles:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>¡Gracias por tu apoyo a [OrgName]!</p>`,
        [Locales.DE]: `<p>Hallo {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung wurde versendet! Hier sind die Details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Vielen Dank für Ihre Unterstützung von [OrgName]!</p>`,
    };
    return bodies[locale];
};
export const getFulfillmentEditorReadyForPickupSubject = (locale) => {
    const subjects = {
        [Locales.EN]: "Your order is ready for pick-up 📦",
        [Locales.DE]: "Ihre Bestellung ist abholbereit 📦",
        [Locales.FR]: "Votre commande est prête pour le ramassage 📦",
        [Locales.ES]: "Tu pedido está listo para recoger 📦",
    };
    return subjects[locale];
};
export const getFulfillmentEditorOrderShippedSubject = (locale) => {
    const subjects = {
        [Locales.EN]: "Your order has shipped 📦",
        [Locales.DE]: "Ihre Bestellung wurde versandt 📦",
        [Locales.FR]: "Votre commande a été expédiée 📦",
        [Locales.ES]: "Tu pedido ha sido enviado 📦",
    };
    return subjects[locale];
};
export const getFulfillmentEditorReadyForPickupBody = ({ locale, orgName, firstName, orderDetails, pickupAddress, pickupInstructions, }) => {
    const bodies = {
        [Locales.EN]: `<p>Hi ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Your order is ready for pick-up! Here are the details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Pick-up address:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Pick-up instructions:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Thank you for supporting ${orgName}!</p>`,
        [Locales.DE]: `<p>Hallo ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung ist abholbereit! Hier sind die Details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Abholadresse:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Abholhinweise:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Vielen Dank für Ihre Unterstützung von ${orgName}!</p>`,
        [Locales.FR]: `<p>Bonjour ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Votre commande est prête pour le ramassage ! Voici les détails :</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Adresse de ramassage :</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Consignes de ramassage :</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Merci de votre soutien envers ${orgName} !</p>`,
        [Locales.ES]: `<p>Hola ${firstName},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido está listo para recoger! Estos son los detalles:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Dirección de recogida:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Instrucciones de recogida:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>¡Gracias por tu apoyo a ${orgName}!</p>`,
    };
    return bodies[locale];
};
export const getFulfillmentEditorOrderShippedBody = ({ locale, orgName, firstName, orderDetails, }) => {
    const bodies = {
        [Locales.EN]: `<p>Hi ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Your order has been shipped! Here are the details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Thank you for supporting ${orgName}!</p>`,
        [Locales.DE]: `<p>Hallo ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung wurde versandt! Hier sind die Details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Vielen Dank für Ihre Unterstützung von ${orgName}!</p>`,
        [Locales.FR]: `<p>Bonjour ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Votre commande a été expédiée ! Voici les détails :</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Merci de votre soutien envers ${orgName} !</p>`,
        [Locales.ES]: `<p>Hola ${firstName},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido ha sido enviado! Estos son los detalles:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>¡Gracias por tu apoyo a ${orgName}!</p>`,
    };
    return bodies[locale];
};
